/*eslint-disable */

import axios from 'axios';
import {bus} from '@/main';
import commonSocket from '@/commonSocket/';
import root from '@/_helpers/roots';
import userInfoForConf from '@/components/private/interview-conference-info-popup/';

var $ = window.jQuery = require('jquery');
let userLeftFromWebinarApiUrl = root.userLeftFromWebinarApiUrl.link;
export default {
  name: 'interview-confernce-page',
  components: {
    'user-info-popup' : userInfoForConf
  },
  props: [],
  data() {
    return {
      selfUserProfileDetails: {},
      apiObj:null,
      domain:process.env.VUE_APP_VIDEO_DOMAIN,
      callerRoomId:'',
      selfUserFullName:'Test',
      toolbarState:false,
      isAudioMuted:false,
      isVideoMuted:false,
      fullScreenState:true,
      userInfoForMeeting:null,
      userInfoStorePopup:true,
      callEndedPopupState:false
    }
  },
  computed: {
  },
  mounted() {
    bus.$on('userInfoStoreBus', (data) => {
      this.userInfoStorePopup = data
    })
    bus.$on('meetingStartAlert', (data) => {
      this.userInfoForMeeting = data
      if(this.userInfoForMeeting){
        this.StartMeetingMethod(this.callerRoomId,  this.userInfoForMeeting.name,  this.userInfoForMeeting.email)
      }
    })
    if (!location.hash) {
      location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    }
    this.callerRoomId = location.hash.substring(1);
  },
  methods: {
    StartMeetingMethod(roomName, dispNme, userEmail) {
      var __self = this
      const options = {
        roomName: roomName,
        width: '100%',
        height: '100%',
        parentNode: document.querySelector('#public-webinar-conf-container'),
        userInfo: {
          email: userEmail,
          displayName: dispNme
        },
      }
      this.apiObj = new JitsiMeetExternalAPI(this.domain, options);
      this.apiObj.on('readyToClose', () => {
        window.location.href = '/interview/left/room/#' + location.hash.substring(1);
      })
    },
    leftUserInfoMethod(){
      if(!this.userInfoForMeeting) return;
      axios.post(userLeftFromWebinarApiUrl, this.userInfoForMeeting)
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.leftUserInfoMethod)
  },
  beforeDestroy() {
    window.addEventListener("beforeunload", this.leftUserInfoMethod)
  },
  beforeCreate: function () {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    $('body').addClass('dashboard')
    $('body').addClass('video_conference_page')
    $('body').addClass('zisti_video_main_wrp')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('dashboard')
    $('body').removeClass('video_conference_page')
    $('body').removeClass('zisti_video_main_wrp')
    next();
  },
}